module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addMediation":"Add a planned mediation"},"fr":{"addMediation":"Ajouter une médiation planifiée"}}')
  delete Component.options._Ctor
}
